import Extend from 'flarum/common/extenders';
import Group from 'flarum/common/models/Group';
import User from 'flarum/common/models/User';
import TwoFactor from './models/TwoFactor';
export default [new Extend.Store() //
.add('two-factor', TwoFactor), new Extend.Model(User) //
.attribute('twoFactorEnabled').attribute('canDisable2FA').attribute('mustEnable2FA').attribute('backupCodesRemaining'), new Extend.Model(Group) //
.attribute('requires2FA')];